'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(props) {
  var options = props.options,
      selected = props.selected;

  var styles = require('./ButtonGroup.scss');

  return _react2.default.createElement(
    'div',
    { className: styles.container },
    options.map(function (o) {
      var _classnames;

      return _react2.default.createElement(
        'span',
        { key: o, className: (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles['option'], true), (0, _defineProperty3.default)(_classnames, styles['option-selected'], o === selected), _classnames)), onClick: function onClick(e) {
            e.preventDefault();props.onClick(o);
          } },
        o
      );
    })
  );
};

// onClick is a callback function that returns the string value of item clicked
ButtonGroup.propTypes = {
  options: _react2.default.PropTypes.array,
  selected: _react2.default.PropTypes.string,
  onClick: _react2.default.PropTypes.func
};

exports.default = ButtonGroup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonGroup/ButtonGroup.jsx
// module id = 2734
// module chunks = 0